module.exports = __webpack_public_path__ + "media/images/slider-end-7b0a047fbfb20cddf01aee2498191a46.svg";